import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ClientMaster from '../../../components/SidebarMenuComponents/MasterComponent/ClientMaster'
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ClientMasterPage() {
    const location = useLocation();
    const clientMaster = location.state;
    console.log("landing page", clientMaster);

    return (
        <Page title="  Client Master  | tiketic" >
           
            <StickyHeader title="Client Master" />

            <ContentStyle>
                <ClientMaster cliMaster={clientMaster} />
            </ContentStyle>
        </Page>
    );
}

